import React from 'react';
import UserInfo from './userInfo';
import PrivateRoute from '../privateRoute';
import { withRouter } from 'react-router';
import { Switch, Redirect } from 'react-router-dom';
import { isRepiWeb } from '../../store/storeFunctions';
import Settings from './settings';
import ReportHistory from './reportHistory';
import SharingGroups from './sharingGroups';
import SharingGroupUsers from './sharingGroupUsers';

class UserDetails extends React.Component {
    render() {
        return (<>
            <Switch>
                <PrivateRoute exact path={`${this.props.match.url}/info`} component={UserInfo} />
                <PrivateRoute exact path={`${this.props.match.url}/reports`} component={ReportHistory} />
                {!isRepiWeb() && <>
                    <PrivateRoute exact path={`${this.props.match.url}/sharing-groups`} component={SharingGroups} permission='UserInfoConsumptionForWholeClient' />
                    <PrivateRoute exact path={`${this.props.match.url}/sharing-groups/:id`} component={SharingGroupUsers} permission='UserInfoConsumptionForWholeClient' />
                    <PrivateRoute exact path={`${this.props.match.url}/settings`} component={Settings} permission='UserInfoSettingsTab' />
                </>}
            </Switch>
            { this.props.match.url === this.props.location.pathname && <Redirect to={`${this.props.match.url}/info`} /> }
        </>)
    }
}

export default withRouter(UserDetails);